import { EventBus } from '@vtblife/event-bus';
import React from 'react';
import { useEventSubscription } from '../../utils/use-event-subscription';
import { Quiz } from '../../components/quiz/quiz';
const eventBus = EventBus.getInstance();
export const openQuiz = (data) => {
    const event = {
        category: 'simple',
        type: 'event:showQuiz',
        data,
    };
    eventBus.publish(event);
};
/** Слушает событие event:showQuiz и показывает квиз */
export const OpenQuizModal = ({ environment }) => {
    const props = useEventSubscription('event:showQuiz');
    const { id } = (props === null || props === void 0 ? void 0 : props.eventData) || {};
    return id ? (React.createElement(Quiz, { ...props.eventData, id: id, isOpen: props.isOpen, onClose: props.onClose, environment: environment })) : null;
};
//# sourceMappingURL=open-quiz-modal.js.map